<template>
<div class="paybody">
    <div class="boxli">
        <img class="success" src="@/assets/img/vip/success.png" alt="">
        <p class="h1">订单提交成功</p>
        <p class="h2">应付金额：<span>¥1699.00</span></p>
        <p class="h3">请在30分钟内完成支付</p>
        <div class="ewm">
            <img :src="imgUrl" alt="">
        </div>
        <p class="h3">请使用微信扫一扫支付</p>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            imgUrl: "http://www.haichacha.net/wechat.jpg"
        };
    },
    computed: {},
    watch: {},
    methods: {},
    created() {},
    mounted() {},
}
</script>

<style lang="less" scoped>
.paybody {
    width: 100vw;
    background: #f5f5f5;
    padding: 20px 0 24px;

    .boxli {
        width: 1200px;
        height: 680px;
        background: #ffffff;
        margin: 0 auto;
        overflow: hidden;

        .success {
            margin: 92px auto 20px;
        }

        p {
            letter-spacing: 1px;
            text-align: center;
        }

        .h1 {
            font-size: 16px;
            font-weight: 600;
            color: #0c1f3d;
        }

        .h2 {
            font-size: 14px;
            color: #666666;
            padding: 54px 0 8px;

            span {
                font-size: 18px;
                font-weight: 600;
                color: #3779ff;
            }
        }

        .h3 {
            font-size: 12px;
            color: #999999;
        }

        .ewm {
            width: 200px;
            height: 200px;
            background-color: #ffffff;
            border: solid 1px #cccccc;
            margin: 18px auto 14px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 170px;
            }
        }

        .h4 {
            font-size: 12px;
            color: #666666;
        }
    }
}
</style>
